exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".handle{cursor:move!important;cursor:-webkit-grabbing!important}", "", {"version":3,"sources":["/app/src/components/Task.vue"],"names":[],"mappings":"AACA,QACE,sBAAwB,AACxB,iCAAoC,CACrC","file":"Task.vue","sourcesContent":["\n.handle {\n  cursor: move !important;\n  cursor: -webkit-grabbing !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":{"safe":true,"reduceIdents":false,"zindex":false,"mergeRules":false,"discardComments":{"removeAll":true}},"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-32b2f772","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Task.vue
// module id = 871
// module chunks = 4